import Modal from '@components/Modal'
import { withTranslate } from '@i18n/utils'

const InfoModal = ({ onDismiss, title, text, buttonText = 'infomodal.button.label', translate: t }) => (
    <Modal
        onClose={onDismiss}
        header={t(title)}
        buttons={[
            {
                label: t(buttonText),
                onClick: onDismiss,
            },
        ]}>
        <T>{text}</T>
    </Modal>
)

InfoModal.propTypes = {
    buttonText: PropTypes.string,
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    onDismiss: PropTypes.func.isRequired,
}

export default withTranslate(InfoModal)
